module.exports = __webpack_public_path__ + "static/media/baseball-ball.46322a63.svg";